import { ThreeDots } from 'react-loader-spinner'

const Loader = () => {
    return <div className='d-flex justify-content-center'>
        <ThreeDots color="#ddd" />
    </div>
}

export default Loader